import React, { createContext } from 'react';
import {
  Action,
  IEditFeatureData,
  IppaInsightData,
  IPpaAction,
  IAnalyticsHomeData,
  ICiTradeAndVolumeData,
  IPptData,
  IReconData,
  IAnalyticsHomeAction,
  ICiTradeAndVolumeAction,
  IAnalyticsSnapshotReportAction,
  IPptAction,
  IReconAction,
} from '../Types/types';
import { EditFeatureInitialState } from '../Reducers/InitialStates/EditFeatureInitialState';
import { PpaInsightInitialState } from '../Reducers/InitialStates/PpaInsightInitialState';
import { AnalyticsHomeInitialState } from '../Reducers/InitialStates/AnalyticsHomeInitialState';
import { AnalyticsSnapshotReportInitialState } from '../Reducers/InitialStates/AnalyticsSnapshotReportInitialState';
import { BiaReportsInitialState } from '../Reducers/InitialStates/BiaReportsInitialState';
import { CiTradeAndVolumeInitialState } from '../Reducers/InitialStates/CiTradeAndVolumeInitialState';
import { PptReportsInitialState } from '../Reducers/InitialStates/PptInitialState';
import { ReconReportsInitialState } from '../Reducers/InitialStates/ReconInitialState';
import { IAnalyticsSnapshotReportType } from '../Types/IAnalyticsSnapshotReportType';
import { IBiaReports, IBiaReportsAction } from '../Types/types2';

export const AppContext = createContext<{
  appData: {
    state: IEditFeatureData;
    dispatch: React.Dispatch<Action>;
  };
  ppaInsight: {
    state: IppaInsightData;
    dispatch: React.Dispatch<IPpaAction>;
  };
  biaReports: {
    state: IBiaReports;
    dispatch: React.Dispatch<IBiaReportsAction>;
  };
  analyticsHome: {
    state: IAnalyticsHomeData;
    dispatch: React.Dispatch<IAnalyticsHomeAction>;
  };
  ciTradeAndVolume: {
    state: ICiTradeAndVolumeData;
    dispatch: React.Dispatch<ICiTradeAndVolumeAction>;
  };

  analyticsSnapshotReport: {
    state: IAnalyticsSnapshotReportType;
    dispatch: React.Dispatch<IAnalyticsSnapshotReportAction>;
  };

  pptReports: {
    state: IPptData;
    dispatch: React.Dispatch<IPptAction>;
  };

  reconReports: {
    state: IReconData;
    dispatch: React.Dispatch<IReconAction>;
  };
}>({
  appData: {
    state: EditFeatureInitialState,
    dispatch: () => null,
  },
  ppaInsight: {
    state: PpaInsightInitialState,
    dispatch: () => null,
  },
  biaReports: {
    state: BiaReportsInitialState,
    dispatch: () => null,
  },
  analyticsHome: {
    state: AnalyticsHomeInitialState,
    dispatch: () => null,
  },
  ciTradeAndVolume: {
    state: CiTradeAndVolumeInitialState,
    dispatch: () => null,
  },

  analyticsSnapshotReport: {
    state: AnalyticsSnapshotReportInitialState,
    dispatch: () => null,
  },
  pptReports: {
    state: PptReportsInitialState,
    dispatch: () => null,
  },
  reconReports: {
    state: ReconReportsInitialState,
    dispatch: () => null,
  },
});
